// tagsInQuerystring is the string for ?tags=...
// examples is the list of examples to filter on
// A new array of examples is returned.

export const filterExamplesList = ({ tagsInQuerystring, examples, matchAnyTag }) => {
  // if there are no tags set, return the full list
  if (tagsInQuerystring === null) return examples;
  // if match any tag is set, filter using 'some', otherwise use 'every'
  let tags = [];
  tagsInQuerystring.split(',').forEach((tag) => {
    tags.push(tag.toLowerCase());
  });
  if (matchAnyTag === true) {
    return examples.filter((example) =>
      tags.some((item) => {
        const exampleTags = example.tags.map((tag) => tag.toLowerCase());
        return exampleTags.includes(item) || exampleTags.includes(`${item}s`);
      })
    );
  }
  return examples.filter((example) =>
    tags.every((item) => {
      const exampleTags = example.tags.map((tag) => tag.toLowerCase());
      return exampleTags.includes(item) || exampleTags.includes(`${item}s`);
    })
  );
};
